export const ru = {
    'back-to-creatives': 'Вернуться к моим креативам',
    'back-to-ideas': 'Вернуться к идеям креативов',
    'back-to-presets': 'Вернуться к шаблонам',
    cancel: 'Отменить',
    create: 'Создать',
    'create-error': 'При создании креатива произошла ошибка. Попробуйте позже.',
    'create-video-error': 'При создании видео креатива произошла ошибка. Попробуйте позже.',
    'crop-revert-confirm-message': 'Отменить изменение изображения?',
    'fetch-error': 'При получении данных креатива произошла ошибка. Попробуйте позже.',
    'fetch-video-error': 'При получении данных видео креатива произошла ошибка. Попробуйте позже.',
    'overlay-name': 'Новый баннер',
    'parameters-errors': 'Невозможно создать креатив, есть ошибки в элементах: {errors}',
    'preview-title': 'Предварительный просмотр',
    'to-creatives': 'Вернуться к списку добавленных',
    'video-ad-name': 'Новый видеокреатив',
    'video-addition-name': 'Новое видеодополнение',
    'video-cpm-audio-name': 'Новый аудио креатив'
};
